import { useState } from "react";
import { FaWhatsapp, FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";

function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!email.trim()) {
      setMessage("Please enter your email.");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(
        "https://aethearia.store/superadmin/api/store-newsletter",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email,
          }),
        }
      );

      const data = await res.json();

      if (data.status) {
        setMessage(data.message || "Newsletter subscribed successfully.");
        setEmail("");
      } else {
        setMessage(data.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Newsletter Error:", error);
      setMessage("Failed to subscribe. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        .site-footer {
          border-top: 1px solid #ddd2c2;
          font-family: Assistant, sans-serif;
        }

        .footer-top {
          padding: 28px 36px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .footer-left {
          display: flex;
          align-items: center;
        }

        .footer-newsletter {
          display: flex;
          align-items: center;
          gap: 20px;
          position: relative;
        }

        .footer-newsletter label {
          font-size: 14px;
          color: #4c144e;
          margin: 0;
          white-space: nowrap;
          font-weight: 100;
        }

        .newsletter-input-box {
          display: flex;
          align-items: center;
          border: 1px solid #4c144e;
          height: 36px;
        }

        .newsletter-input-box input {
          width: 240px;
          height: 34px;
          border: none;
          background: transparent;
          padding: 0 12px;
          outline: none;
          font-size: 14px;
          color: #17130f;
        }

        .newsletter-input-box input::placeholder {
          color: #8c7288;
        }

        .newsletter-input-box button {
          height: 34px;
          border: none;
          border-left: 1px solid #664e64;
          background: #664e64;
          color: #fff;
          padding: 0 16px;
          font-size: 13px;
          cursor: pointer;
          transition: 0.3s ease;
        }

        .newsletter-input-box button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .newsletter-message {
          position: absolute;
          left: 180px;
          top: 42px;
          font-size: 12px;
          color: #4c144e;
          margin: 0;
        }

        .footer-social-box {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .footer-social-box a {
          color: #000;
          font-size: 18px;
          display: flex;
          transition: 0.3s ease;
        }

        .footer-social-box a:hover {
          color: #4c144e;
          transform: translateY(-2px);
        }

        .footer-bottom {
          border-top: 1px solid #eadcc9;
          min-height: 36px;
          display: flex;
          align-items: center;
          padding: 0 22px;
          gap: 24px;
        }

        .footer-rights {
          padding: 8px 12px;
          margin: 0;
          font-size: 14px;
          letter-spacing: 1.3px;
          color: #4c144e;
          white-space: nowrap;
          font-weight: 100;
        }

        .footer-links {
          display: flex;
          align-items: center;
          gap: 50px;
          flex-wrap: wrap;
        }

        .footer-links a {
          position: relative;
          text-decoration: none;
          font-size: 14px;
          color: #4c144e;
          white-space: nowrap;
          transition: 0.3s ease;
          font-weight: 100;
        }

        .footer-links a:hover {
          color: #4c144e;
        }

        @media (max-width: 991px) {
          .footer-top {
            padding: 25px 22px;
          }

          .footer-bottom {
            flex-direction: column-reverse;
            align-items: flex-start;
            padding: 18px 22px;
            gap: 16px;
          }

          .footer-links {
            gap: 16px;
          }
        }

        @media (max-width: 640px) {
          .footer-top {
            flex-direction: column;
            align-items: center;
            gap: 18px;
            padding: 30px 20px 25px;
          }

          .footer-newsletter {
            width: 100%;
            flex-direction: column;
            align-items:center;
            gap: 10px;
          }

          .newsletter-input-box {
            width: 100%;
          }

          .newsletter-input-box input {
            width: 100%;
          }

          .newsletter-message {
            position: static;
            text-align: center;
            margin-top: 4px;
          }

          .footer-bottom {
            align-items: flex-start;
            text-align: center;
          }

          .footer-links {
            justify-content: center;
            gap: 18px 20px;
          }

          .footer-links a {
            font-size: 12px;
          }

          .footer-rights {
            white-space: normal;
            line-height: 1.6;
            font-size: 9px;
                    text-align: center;
          }
            .footer-left{
            width:90%
            }
        }
      `}</style>

      <footer className="site-footer">
        <div className="footer-top">
          <div className="footer-left">
            <form className="footer-newsletter" onSubmit={handleNewsletterSubmit}>
              <label>Join The Aethearia Circle</label>

              <div className="newsletter-input-box">
                <input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />

                <button type="submit" disabled={loading}>
                  {loading ? "Joining..." : "Join"}
                </button>
              </div>

              {message && <p className="newsletter-message">{message}</p>}
            </form>
          </div>

          <div className="footer-social-box">
           <a
            href="https://wa.me/919975511512"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp />
          </a>

            <a
              href="https://www.instagram.com/aethearia_ethereal?igsh=eTVubHlic2ptcG1z"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-rights">
            © 2026 AETHER FALCON ENDEAVORS. All Rights Reserved.
          </p>

          <div className="footer-links">
            <Link to="/contact">Contact Us</Link>
            <Link to="/shipping-policy">Shipping Policy</Link>
            <Link to="/return-exchange-policy">Return & Exchange</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-and-conditions">Terms of Service</Link>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;